import { Boolean, Null, Number, Optional, Record, Static, String } from 'runtypes';

export const AppointmentListItemRunType = Record({
	access: Optional(String),
	aggregateId: Optional(String),
	allDay: Boolean,
	appointmentId: Number,
	calendarId: Optional(Number.Or(String)),
	color: Optional(String.Or(Null)),
	confirmedByUser: Optional(String),
	creatorAbbreviation: Optional(String),
	creatorContactPicture: Optional(String),
	creatorId: Optional(String),
	description: Optional(String),
	dstChange: Optional(String),
	endDate: String,
	endDateOriginal: String,
	insightRight: Optional(String),
	linkedIdoCounter: Optional(Number),
	location: Optional(String),
	needsConfirmation: Optional(String),
	participants: Optional(String.Or(Null)),
	participation: Optional(String),
	startDate: String,
	startDateOriginal: String,
	timeMode: Optional(String),
	title: String,
	writepermission: Optional(String),
});

export type AppointmentListItem = Static<typeof AppointmentListItemRunType>;
export type AppointmentListActiveView = 'day' | 'month' | 'week' | 'year' | 'years';
export type AppointmentListSelectedView = 'day' | 'list' | 'month' | 'week' | 'year' | 'years';

export const AppointmentListExtrasRunType = Record({
	description: String,
	duration: String,
	isAnInformativeAppointment: Boolean,
	location: String.Or(Null),
	timeMode: String,
});

export const PermittedUserCalenderRunType = Record({
	fullUserName: String,
	realUserName: String,
	userAvatar: String,
	userId: Number,
});

export type PermittedUserCalender = Static<typeof PermittedUserCalenderRunType>;
